module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fblogin-container"
  }, [(_vm.logged == 'cancelled') ? _c('div', [_vm._t("cancelled"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n  \t\t\tFacebook Login\n  \t\t")])], 2) : (_vm.logged == 'not_logged') ? _c('div', [_vm._t("check-login", [_vm._v("\n  \t\t\tconnecting with facebook...\n  \t\t")])], 2) : (_vm.logged == 'logged') ? _c('div', [_vm._t("logged", [_vm._v("\n        already logged in...\n  \t\t")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fb-send-to-messenger",
    staticStyle: {
      "display": "inherit"
    },
    attrs: {
      "id": "fb-send-to-messenger",
      "messenger_app_id": "782732588553167",
      "page_id": "418381418548219",
      "data-ref": "PASS_THROUGH_PARAM",
      "color": "white",
      "size": "standard"
    }
  }, [_vm._v("\n      subscribe chat bot\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://noctorus.studio/",
      "data-layout": "button",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "false"
    }
  }, [_vm._v("\n      like button\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a36ef69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBLogin.vue
// module id = 823
// module chunks = 1